import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CountdownOverlay = ({ countdown }) => {
    // Debugging log to track prop updates in console
    React.useEffect(() => {
        if (countdown !== null) {
            console.log(`[CountdownOverlay] Received tick: ${countdown}`);
        }
    }, [countdown]);

    return (
        <AnimatePresence>
            {countdown !== null && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{ 
                        backgroundColor: 'rgba(15, 23, 42, 0.65)', 
                        backdropFilter: 'blur(12px)',
                        WebkitBackdropFilter: 'blur(12px)',
                        zIndex: 99999,
                        pointerEvents: 'none',
                        userSelect: 'none'
                    }}
                >
                    <div className="text-center">
                        <div style={{ height: '320px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={countdown}
                                    initial={{ scale: 0.5, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    exit={{ scale: 1.5, opacity: 0 }}
                                    transition={{ 
                                        type: "spring", 
                                        stiffness: 300, 
                                        damping: 30,
                                        duration: 0.4 
                                    }}
                                    className="fw-bold"
                                    style={{ 
                                        fontSize: '18rem',
                                        color: 'white',
                                        textShadow: '0 0 50px rgba(255, 255, 255, 0.4), 0 10px 30px rgba(0,0,0,0.3)',
                                        fontWeight: '800',
                                        fontFamily: "'Outfit', sans-serif",
                                        letterSpacing: '-0.5rem',
                                        lineHeight: 1
                                    }}
                                >
                                    {countdown === 0 ? 'GO!' : countdown}
                                </motion.div>
                            </AnimatePresence>
                        </div>

                        <motion.div 
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.1 }}
                            className="h2 text-white text-uppercase mt-2"
                            style={{ 
                                letterSpacing: '0.8rem', 
                                fontWeight: '600',
                                opacity: 0.8,
                                textShadow: '0 2px 10px rgba(0,0,0,0.2)'
                            }}
                        >
                            {countdown === 0 ? 'HAZIR OLUN' : 'HAZIRLANIN'}
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CountdownOverlay;
